import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Panel, DsButton } from "../ds";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const u = await login(email, password);
      toast.success("Signed in.");
      navigate(u?.must_change_password ? "/change-password" : (location.state?.from || "/"));
    } catch (ex) {
      setErr(ex?.response?.data?.detail || "Could not sign in.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 dark" style={{ background: "var(--bg)" }}>
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2.5 mb-8 justify-center">
          <svg width="22" height="22" viewBox="0 0 18 18" aria-hidden="true">
            <rect x="2" y="8" width="14" height="3" rx="0.5"
                  fill="var(--cobalt)" transform="rotate(-24 9 9.5)" />
          </svg>
          <div className="leading-tight">
            <div className="font-ui font-bold text-xl text-[color:var(--fg)]">
              Stackly <span className="text-[color:var(--muted)] font-medium">Office</span>
            </div>
          </div>
        </div>

        <Panel label="CEO SIGN-IN">
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="font-mono text-[10.5px] uppercase tracking-[0.1em] text-[color:var(--muted)]">Email</label>
              <input
                type="email" required autoFocus
                autoComplete="username"
                data-testid="login-email"
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full h-10 rounded-[5px] border border-[color:var(--line-2)] bg-[color:var(--bg)] px-3 text-sm text-[color:var(--fg)] outline-none focus:border-[color:var(--cobalt)]"
              />
            </div>
            <div>
              <label className="font-mono text-[10.5px] uppercase tracking-[0.1em] text-[color:var(--muted)]">Password</label>
              <input
                type="password" required
                autoComplete="current-password"
                data-testid="login-password"
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full h-10 rounded-[5px] border border-[color:var(--line-2)] bg-[color:var(--bg)] px-3 text-sm text-[color:var(--fg)] outline-none focus:border-[color:var(--cobalt)]"
              />
            </div>
            {err && (
              <div className="text-sm" style={{ color: "var(--bad)" }} data-testid="login-error">{err}</div>
            )}
            <DsButton type="submit" variant="primary" disabled={busy} data-testid="login-submit" className="w-full h-11 text-sm">
              {busy ? "Signing in…" : "Sign in"}
            </DsButton>
          </form>
        </Panel>
        <p className="text-center font-mono text-[10px] text-[color:var(--muted)] mt-6">
          by Stackly · Software Studio FZCO
        </p>
      </div>
    </div>
  );
}
